import { configureStore } from '@reduxjs/toolkit'
import userSlice from './userSlice.js'
import workdirSlice from './workdirSlice.js'
import entityIdsSlice from './entityIdsSlice.js'

export default configureStore({
	reducer: {
		user: userSlice,
		workdir: workdirSlice,
		entityIds: entityIdsSlice,
	},
})
